import { useContext } from 'react';
import { ToastContext } from './ToastContext';

export const useToastNotification = () => {
  const { openToast } = useContext(ToastContext);
  return openToast;
};
